__turbopack_context__.v({
  "buttonAction": "actions-module-scss-module__yH72-G__buttonAction",
  "disabled": "actions-module-scss-module__yH72-G__disabled",
  "isActionItemVisible": "actions-module-scss-module__yH72-G__isActionItemVisible",
  "mobileAdditionalOptionsTrigger": "actions-module-scss-module__yH72-G__mobileAdditionalOptionsTrigger",
  "mobileDropdownContent": "actions-module-scss-module__yH72-G__mobileDropdownContent",
});
